export const get = key => {
    return sessionStorage.getItem(key);
};

export const set = (key, data) => {
    return sessionStorage.setItem(key, data);
};

export const remove = key => {
    return sessionStorage.removeItem(key);
};

export default {
    get,
    set,
    remove
};